import React from "react";

export default function ProfitStatCard({ stripeClassName, label, value, children }) {
  return (
    <div className="profit-kpi-card">
      <div className={"profit-kpi-stripe " + stripeClassName} />
      <div className="profit-kpi-label">{label}</div>
      <div className="profit-kpi-value">{value}</div>
      <div className="profit-kpi-sub">{children}</div>
    </div>
  );
}
